export class StringHelper {
  public static isBlank(value: string): boolean {
    return value === undefined || value === null || value === "";
  }

  public static isPresent(value: string): boolean {
    return !this.isBlank(value);
  }
}
